module.exports = __webpack_public_path__ + "img/535.28be4b06.png";